import { Grid, Typography, useScrollTrigger } from '@mui/material'
import React from 'react'
import { useResponsive } from '../../hooks/useResponsive';

export const MobileHeader = () => {
    const trigger = useScrollTrigger();
    const isMobile = useResponsive("down", "md");

    return (
        <>
            <Grid
                container
                item
                xs={12}
                className="remove-container-width fixed-ui"
                sx={{ top: trigger ? "0px" : isMobile ? "51px" : "" }}
                justifyContent={"center"}
                pb={"16px !important"}
                pt={trigger ? "24px !important" : "20px !important"}
                alignItems={"center"}>
                <Grid
                    item
                    xs={12}
                    md={12}
                    lg={12}
                    className="d-flex align-items-center">
                    <Typography fontWeight={600}>Watching Tasks</Typography>
                </Grid>
            </Grid>
        </>
    )
}

